import { lang, StringKeyObjectMap } from "./lang";

const useLang = (locale: string = "en") => {
  return lang[locale];
};

const getLanguage =
  (text: StringKeyObjectMap) => (name: string, fallback?: string) => {
    if (text[name] === undefined && fallback === null) {
      throw new Error(`Cannot find ${name} in lang file.`);
    }

    if (text[name] === undefined) {
      return fallback || "UNDEFINED";
    }

    return text[name];
  };

export { useLang, getLanguage };
